(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    $(document).ready(function() {
  $('.color-swatch').each(function () {
      if ($(this).prev('input[type="radio"]').is(':checked')) {
         var CustomColorV = $(this).data('color');
         $(".product__media_controlar , .banner_outer_image").each(function(index, element) {
        var CustomColorT = $(this).data('color');
        if(CustomColorV === CustomColorT){
            $(this).show();
        }else{
            $(this).hide();
        }
      });     
    }
  });
  // on loads ends here.

  // on click starts from here.
  $(document).on('click', '.color-swatch', function () {
   var CustomColorV = $(this).data('color'); 
   $(".product__media_controlar , .banner_outer_image").each(function(index, element) {
   var CustomColorT = $(this).data('color');
   if(CustomColorV === CustomColorT){
      $(this).show();
   }else{
      $(this).hide();
   }  
  });  
 });

// document .ready ends.
});
  } catch(e) { console.error(e); }
})();

})();
